import React from 'react';
import { ArrowLeft, BellRing, Coins, Eye, Share2, Sparkles } from 'lucide-react';
import { LiveIdentityBadge } from './LiveIdentityBadge';
import { demoCover, formatEuro } from './liveTheme';

export const LiveSessionProfile = ({ session, lang, token, onEnter, onToggleNotification, notificationEnabled, onAuth, onBack }) => {
  const cover = session.cover_image || session.artist_photo || demoCover(0);

  return (
    <section data-testid="pulse-live-session-profile" className="rounded-2xl overflow-hidden bg-[#111] border border-white/8">
      <div className="relative aspect-[2.2/1] overflow-hidden">
        <img src={cover} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#111] via-black/30 to-transparent" />
        {onBack && (
          <div className="absolute top-4 left-4">
            <button data-testid="pulse-live-profile-back" onClick={onBack} className="rounded-full bg-black/40 backdrop-blur-sm p-2 text-white/70 hover:text-white transition">
              <ArrowLeft size={18} />
            </button>
          </div>
        )}
        <div className="absolute bottom-4 left-4 right-4">
          <LiveIdentityBadge session={session} lang={lang} />
          <h2 data-testid="pulse-live-profile-title" className="text-2xl md:text-3xl font-bold text-white mt-2">{session.title}</h2>
          <p className="text-sm text-white/50 mt-1">{session.artist_name}</p>
        </div>
      </div>

      <div className="p-4 md:p-5 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <button data-testid="pulse-live-enter-now" onClick={token ? onEnter : onAuth} className="rounded-full bg-white text-black px-6 py-2.5 text-sm font-semibold hover:bg-white/90 transition">
            {lang === 'es' ? 'Entrar' : 'Enter'}
          </button>
          <button data-testid="pulse-live-toggle-notify" onClick={token ? onToggleNotification : onAuth} className="rounded-full bg-white/5 border border-white/10 px-4 py-2.5 text-white/60 hover:text-white text-sm transition flex items-center gap-2">
            <BellRing size={14} /> {notificationEnabled ? (lang === 'es' ? 'Activo' : 'On') : (lang === 'es' ? 'Avisar' : 'Alert')}
          </button>
          <button data-testid="pulse-live-share-button" className="rounded-full bg-white/5 border border-white/10 p-2.5 text-white/60 hover:text-white transition">
            <Share2 size={14} />
          </button>
        </div>
        <div className="flex items-center gap-3 text-[12px] text-white/35">
          <span className="flex items-center gap-1"><Eye size={12} /> {session.viewers || 0}</span>
          <span className="flex items-center gap-1"><Coins size={12} /> {formatEuro(session.total_donations || 0)}</span>
          <span className="flex items-center gap-1"><Sparkles size={12} /> {session.social_power || 0}</span>
        </div>
      </div>
    </section>
  );
};
